/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListCopyRequest} from '@cash-web/protos/squareup/consentsys/service.pb'
import {ListCopyResponse} from '@cash-web/protos/squareup/consentsys/service.pb'


export const listCopy = (request:ListCopyRequest, options?: CashRequestOptions) => post<ListCopyRequest, ListCopyResponse>("/2.0/cash/list-copy", request, {...options, rejectOnError: true })